import { FieldControllerProps } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

const PROVIDER_CODE_MAX_LENGTH = 16;

type ProviderCodeInputProps = FieldControllerProps<'providerCode', string | null>;

export const ProviderCodeInput = (props: ProviderCodeInputProps): JSX.Element => {
   const controller = props.register(props.name, { required: props.required });

   return (
      <TextInput
         label={nfzSettingsTranslationKeys.providerCode}
         controller={controller}
         testId={props.name}
         defaultValue={props.defaultValue}
         maxLength={PROVIDER_CODE_MAX_LENGTH}
      />
   );
};
